// extracted by mini-css-extract-plugin
export default {"link":"AdminMobileTable_link__VR-RD","chatIcon":"AdminMobileTable_chatIcon__GIYLp","table":"AdminMobileTable_table__XwE49","more":"AdminMobileTable_more__+pb9I"};